import * as React from 'react';

class SimpleInputAgGridEditor extends React.Component {
  state = {
    inpVal: '',
  };

  componentDidMount() {
    const {column, required, finStrIndex} = this.props;

    this.setState({inpVal: this.props.value});
    if (this.props.value === '' && required) {
      this.checkErrorSetFunctionType('Field is required', column.colId, finStrIndex);

    }
  }

  getValue = () => {
    return this.state.inpVal;
  };

  onChange = (e) => {
    const {column, agGridReact, node} = this.props;
    if (column.colDef.scenarioShow) {
      const data = node.data;
      data[column.colId] = e.target.value;
      agGridReact.props.scenarioFinStrDataChange(data);
    }
    this.validationSetter(e.target.value);
    this.setState({inpVal: e.target.value});

  };

  checkErrorSetFunctionType = (errorType, columnName, finStrIndex) => {
    const {setFinSchemaError, setDealRoomFinSchemaErrors} = this.props.agGridReact.props;

    if (setFinSchemaError) {
      setFinSchemaError(errorType, columnName)
    } else {
      setDealRoomFinSchemaErrors(errorType, columnName, finStrIndex);
    }
  };

  validationSetter = (value) => {
    const {type, column, required, finStrIndex} = this.props;
    if (required && value === '') {
      this.checkErrorSetFunctionType('Field is required', column.colId, finStrIndex);
    } else {
      if (type === "number") {
        if (+value !== 0 && !+value) {
          this.checkErrorSetFunctionType('Field must be Number', column.colId, finStrIndex);
        } else {
          this.checkErrorSetFunctionType('', column.colId, finStrIndex);

        }
      } else if (type === "integer") {
        if (!Number.isInteger(+value)) {

          this.checkErrorSetFunctionType('Field must be Integer', column.colId, finStrIndex);

        } else {
          this.checkErrorSetFunctionType('', column.colId, finStrIndex);

        }
      } else {
        this.checkErrorSetFunctionType('', column.colId, finStrIndex);

      }
    }
  };

  render() {
    return <input type="text" value={this.state.inpVal} onChange={this.onChange}/>;
  }
}

export default SimpleInputAgGridEditor;


// WEBPACK FOOTER //
// ./src/views/FinancicalStructure/FinancicalStructure/FieldRenderer/SimpleInputAgGridEditor.js